module.exports = __webpack_public_path__ + "img/tertiary_3x1_z18.65559341.svg";